<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '1')"
        v-if="checkShowTabs('数据源')"
        title="数据源"
        name="1"
      >
        <div class="data-source-type mb12">
          <cx-slider :value.sync="isLocal" :options="dataOptions" :height="32" />
        </div>
        <div v-if="isLocal === true" class="dataSource-item" @click="goToChooseData">
          <span>进入数据管理后台 </span>
        </div>
        <data-center-choose 
          v-show="isLocal === false"
          :checkStatus="checkStatus"
          :myId="myId"
          :options="getOptions"
          :jumpDirect="true"
          :key="checkStatus"
          @onDataCenterChange="onDataCenterChange"
          @onBeforeDataCenterUpdate="onBeforeDataCenterUpdate"
          @onAfterDataCenterUpdate="onAfterDataCenterUpdate"
        />
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        v-if="checkShowTabs('数据绑定') && !!ids.uid && getAllElements.length"
        name="2"
        class="mapping_container"
      >
        <div
          v-for="(item, index) in getAllElements"
          :key="index"
          :class="item.filedMapping.flag && item.filedMapping.value ? 'mapping_content checked' : 'mapping_content'"
          @mouseenter="highlightedBaseComponent(item.elementInLayoutId, item.elementInAutoLayoutId, item.path)"
          @mouseleave="cancelHighlightedBaseComponent(item.elementInLayoutId, item.elementInAutoLayoutId, item.path)"
        >
          <div class="verticallyBetweenCenter">
            <div class="content-title">
              {{ getValueByTypeHandle(item.innerElement) }}
            </div>
            <div class="verticallyCenter" v-if="!item.filedMapping.isDate && item.filedMapping.flag && (item.innerElement=='cxText' || item.innerElement=='cxButton')">
              <el-checkbox v-model="item.isHyperlink" @change="changeItemOptions($event, item,'isHyperlink')">超链接</el-checkbox>
              <el-tooltip popper-class="maxWidth160" placement="top" :open-delay="1000" content="勾选后，会出现链接地址配置项，可关联数据源链接字段"><i class="tips-btn icon-portal-info2"></i></el-tooltip>
            </div>
          </div>
          <div class="select_content mt8">
            <el-select
              style="width: 100%"
              v-model="item.filedMapping.value"
              @change="
                changeFiledMappingHandle(
                  $event,
                  {
                    elementInLayoutId: item.elementInLayoutId,
                    elementInAutoLayoutId: item.elementInAutoLayoutId,
                    path: item.path,
                    flag: 'value'
                  },
                  true
                )
              "
              placeholder="请选择"
              clearable
            >
              <el-option v-for="(item1, index1) in filedMappingList" :key="index1" :label="item1.label" :value="item1.value">
                <span style="font-size: 13px">{{ item1.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div
            class="verticallyCenter mapping_date_content mt8"
            v-if="item.filedMapping.flag && !item.filedMapping.isDate && item.innerElement === 'cxText'"
          >
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeMappingType($event, item)">
              <span class="el-dropdown-link">
                {{ fieldMappingDataType(item.filedMapping) }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
                <el-dropdown-item v-for="item1 in dataTypeList" :key="item1.value" :command="item1.value">
                  <div :class="item.filedMapping.dataType === item1.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item1.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="verticallyCenter mapping_date_content mt8" v-if="item.filedMapping.flag && item.filedMapping.isDate">
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeMappingDateStyle($event, item)">
              <span class="el-dropdown-link">
                {{ fieldMappingDateStyle(item.filedMapping) }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
                <div class="dropdown-title-show">
                  <cx-check-box :value.sync="item.filedMapping.dateTitle" @change="onChangeMappingDateTitle">显示字段名</cx-check-box>
                </div>
                <el-dropdown-item v-for="item1 in dateOptions" :key="item1.value" :command="item1.value">
                  <div :class="item.filedMapping.dateStyle === item1.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item1.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="item.innerElement == 'cxVideo' || item.innerElement == 'cxAudio'" class="vedio-style mt8">
            <el-checkbox v-model="item.videoObjectId" @change="changeItemOptions($event, item,'videoObjectId')"></el-checkbox><label>支持云盘</label>
          </div>
          <div class="select_content mt8" v-if="item.isHyperlink">
            <el-select
              v-if="item.filedMapping.flag"
              v-model="item.filedMapping.linkUrl"
              @change="
                changeFiledMappingHandle(
                  $event,
                  {
                    elementInLayoutId: item.elementInLayoutId,
                    elementInAutoLayoutId: item.elementInAutoLayoutId,
                    path: item.path,
                    flag: 'linkUrl'
                  },
                  true
                )
              "
              placeholder="请选择"
              clearable
            >
              <el-option v-for="(item1, index1) in filedMappingList" :key="index1" :label="item1.label" :value="item1.value">
                <span style="font-size: 13px">{{ item1.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mt4" v-if="item.isHyperlink">
            <el-checkbox v-model="item.openBlankPage" @change="changeItemOptions($event, item,'openBlankPage')">新页面打开</el-checkbox>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '4')"
        v-if="checkShowTabs('链接跳转') && !!ids.uid && getAllElements.length && isLocal !== '3'"
        title="链接跳转"
        name="4"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <div class="setting-item">请选择点击区域</div>
          <div class="setting-item syncCol_content">
            <el-checkbox
              v-model="getAllElementsIsCheckedAll"
              :indeterminate="allElementsIsCheckedAll"
              class="ml8"
              @change="checkAllElementsHandle"
            ></el-checkbox
            ><label>全部</label>
            <li
              v-for="(item, index) in getAllElements"
              class="col_li"
              :key="index"
              @mouseenter="highlightedBaseComponent(item.elementInLayoutId, item.elementInAutoLayoutId, item.path)"
              @mouseleave="cancelHighlightedBaseComponent(item.elementInLayoutId, item.elementInAutoLayoutId, item.path)"
            >
              <el-checkbox
                v-model="item.filedMapping.checked"
                @change="
                  changeFiledMappingHandle(
                    $event,
                    { elementInLayoutId: item.elementInLayoutId, elementInAutoLayoutId: item.elementInAutoLayoutId, path: item.path, flag: 'checked' },
                    false
                  )
                "
              ></el-checkbox>
              <span>{{ getValueByTypeHandle(item.innerElement) }}</span>
            </li>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="isLocal !== '3'"
        @mousedown.native="collapseMouseDown($event, '5')"
        title="更多"
        name="5"
      >
        <auto-update-timer :isOpenPagination="isOpenPagination" :options="getOptions" :isLocal="isLocal" unit="分" :step="0.1" :minVal="0.1" />
        <div class="getDataBtn mt12 mb12" @click="startDraw">查看数据响应结果</div>
        <cx-check-box v-if="request_prefix==='bigScreen'" :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
        <cx-check-box :value.sync="linkNoProxy">详情页原地址访问</cx-check-box>
        <!-- 用于详情页 需要向数据源传递详情页表单信息 -->
        <div class="verticallyCenter" v-if="pageType === 'detailPage'">
          <cx-check-box :value.sync="useSubPageQuery">数据源参数</cx-check-box>
          <i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
        </div>
        <!--  用于详情页 自定义传参-->
        <div v-if="pageType === 'detailPage' && useSubPageQuery" class="content-item card mt8">
          <el-checkbox-group v-model="selectedDetailParam" class="custom-param-checkbox">
            <el-checkbox :key="index" :label="param.label" v-for="(param, index) in detailParams"></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span
          >开启后，在数据源请求时，会在"searchKeys"中的"sw"中返回子页面参数；如果使用了“requestUrl”，会在请求中增加子页面参数</span
        >
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import colsElementDescriptor from "../utilsComponents/colsElementDescriptor/colsElementDescriptor.vue"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import {
  handleFindLayoutComponentOptions,
  handleFindLayoutComponentAllUid,
  getValueByType,
  handleFindLayoutComponentOptionsCols,
  findAllComponentsInTitleOptions,
  recordOldSize,
  checkIsYzDatacenter
} from "utils"
import { deepChangeUid, replaceUrlParam, getAllColsUidInLayoutComponent, isExist } from "../../../utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import { CATEGORY_MODE, TYPE_FIELD_MAPPING } from "../../../consts"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  components: {
    colsElementDescriptor,
    autoUpdateTimer,
    dataCenterChoose
  },
  props: {
    options: { type: Object }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      changeAll: false,
      preventRadio: null,
      preventType: null,
      chooseFromVisable: false,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      restDataUrl: null,
      restUrl: null,
      otherParams: null,
      activeNames: ["1"],
      collapseActiveNames: [],
      completeData: [],
      filedMappingList: [], // 用来做映射的字段集合
      allCols: [], // 用来做需要同步的col集合
      allColsIsCheckedAll: false,
      getAllColsIsCheckedAll: false, // 是否全选所有col
      allElementsIsCheckedAll: false,
      getAllElementsIsCheckedAll: false, //是否全选所有元素
      checkedCols: [],
      detailPageElementIndexList: [], //当前col中可以跳转链接的组件
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      fetchEnd: false,
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/params-tips.png"),
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      detailParams: [],
      appId: null,
      isLocal: null,
      localManual: true,
      source: 1
    }
  },
  computed: {
    isTypeRenderMode() {
      return this.getOptions?.pluginName?.includes("renderTypeCol")
    },
    showColsData() {
      if (this.getOptions.hasOwnProperty("showColsData") === false) return true
      return this.getOptions.showColsData
    },
    typeVal() {
      const rectAttr = this.getOptions
      return this.cacheDataTypes?.length ? this.cacheDataTypes[rectAttr.activeIndex].label : null
    },
    getOptions: function () {
      let rect = this.getRectAttribute.call(this, this.ids)
      if (rect && this.ids.elementInAutoLayoutId !== undefined && rect.shape === "cxAutoLayout") {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    ids() {
      return this.$store.state.states.activeID
    },
    reverseGetColsUid: {
      get() {
        return this.getOptions && this.getOptions.reverseGetColsUid ? this.getOptions.reverseGetColsUid : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "reverseGetColsUid", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    linkNoProxy:{
      get() {
        return this.getOptions.linkNoProxy || false
      },
      set(newVal) {
        this.setLinkNoProxt(newVal)
      }
    },
    isOpenPagination(){
      // 判断是否开启了分页
      let pagination
      this.getOptions.titleOptions.forEach(title=>{
         if(!title.isShow){
           return
         }
        pagination = title.elementOptions.find(item=>item.type === "pagination")
      })
      return pagination && pagination.isShow
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    useSubPageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "useSubPageQuery", "useSubPageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "useSubPageQuery", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    selectedDetailParam: {
      get() {
        return this.getOptions.hasOwnProperty("selectedDetailParam") ? this.getOptions.selectedDetailParam : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectedDetailParam", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    noCacheComponent: {
      get() {
        return this.getOptions && this.getOptions.noCacheComponent ? this.getOptions.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    getAllElements() {
      if (!this.ids.uid) return // 没有uid说明选中的是整个布局，只有选中布局中的col才进后续逻辑
      let checkedLength = 0
      const pOptions = this.getOptions.rows
      let componentBoxOptions = JSON.parse(JSON.stringify(handleFindLayoutComponentOptions(pOptions, this.ids.uid)))
      let cxAutoLayout = false
      componentBoxOptions.forEach((it, index) => {
        //  处理单元格里的脏数据--自由布局 todo
        if (it.shape === "emptyLayoutComponent") {
          this.$store.dispatch(this.request_prefix + "/deleteElement", {
            ...this.ids,
            elementInLayoutId: it.elementInLayoutId
          })
          // 删除自由布局
          componentBoxOptions.splice(index, 1)
        }
        if (it.innerElement === "cxAutoLayout") {
          cxAutoLayout = true
          componentBoxOptions.splice(index, 1, it.elementOptions)
        }
      })
      if (cxAutoLayout && Array.isArray(componentBoxOptions)) {
        componentBoxOptions = componentBoxOptions.flat(1)
      }
      for (let i = 0; i < componentBoxOptions.length; i++) {
        const newVal = this.checkAndSetPrimaryVal(componentBoxOptions[i], "filedMapping", "filedMapping", {
          value: null,
          label: null,
          flag: false,
          checked: false,
          isDate: false,
          dateStyle: "1",
          dateTitle: false,
          dataType: "dataValue"
        })
        if (newVal) {
          // 以前未设置的 加个默认值
          if (!newVal.dataType) {
            newVal.dataType = "dataValue"
          }
          if (!newVal.dateTitle) {
            newVal.dateTitle = false
          }
          this.$changeOptionsEV(newVal, "filedMapping", false, null, {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            uid: this.ids.uid,
            elementInLayoutId: componentBoxOptions[i].elementInLayoutId,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          }, true)
        }
        if (componentBoxOptions[i].filedMapping?.checked) checkedLength++
      }
      this.getAllElementsIsCheckedAll = checkedLength === componentBoxOptions.length
      this.allElementsIsCheckedAll = checkedLength > 0 && checkedLength < componentBoxOptions.length
      return componentBoxOptions
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    isSearchListPage() {
      return this.$store.state[this.request_prefix].page.pluginName?.includes("searchListPagePlugin") || false
    },
    isGroupSearchListPage() {
      return this.$store.state[this.request_prefix].page.pluginName?.includes("groupSearchListPagePlugin") || false
    },
    dataOptions() {
      const options = [{ value: true, title: "本地数据" }, { value: false, title: "数据中心" }]
      if (this.pageType === "detailPage") {
        options.push({ value: "3", title: "多图详情" })
      }
      return options
    },
    checkStatus() {
      return this.getOptions.appId
    },
    myId() {
      return {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }
    },
    clickState: {
      get() {
        return this.getOptions.clickState
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clickState", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    requestUrl: {
      get() {
        return this.getOptions.requestUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "requestUrl", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
  },
  watch: {
    isLocal: {
      handler(newVal) {
        // 手动切换到本地数据
        if(newVal === true && this.localManual && this.getOptions.appId && this.source !== 1) {
          this.$confirm("确定使用本地资源？", "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            dangerouslyUseHTMLString: "<p>确定使用本地资源？</p>",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          }).then(() => {
            this.$API.setLocalData({ appId: this.getOptions.appId, type: "general" }).then(() => {
              this.isLocal = true
              this.source = 1
              this.$changeOptionsEV("", "dataCenterName", false, null, this.myId, true)
              this.$changeOptionsEV(false, "useYzDataCenter", false, null, this.myId, true)
              this.startDraw()
            })
          }).catch((e) => {
            this.isLocal = false
          })
        }
        if(this.pageType === "detailPage" && this.localManual) {
          if(newVal === "3") {
            if(this.getOptions.myFetchParam) {
              this.$changeOptionsEV("", "myFetchParam", false, null, this.myId, true)
            }
            this.$changeOptionsEV("", "appId", false, null, this.myId, true)
            this.$changeOptionsEV("", "dataCenterName", false, null, this.myId, true)
            this.$changeOptionsEV(true, "multiImageDetail", false, null, this.myId, true)
            this.startDraw()
          } else {
            this.$changeOptionsEV(false, "multiImageDetail", false, null, this.myId, true)
          }
        }
        this.localManual = true
      }
    },
    "getOptions.appId": {
      handler(newVal) {
        if(newVal) {
          this.startDraw()
        }
      }
    }
  },
  methods: {
    async setLinkNoProxt(newVal){
      let engineInstanceId = this.getOptions.engineInstanceId
      if(!engineInstanceId){
        const data = !this.hasGetDetailDataPlugin && await this.getAppointDataEv() || {}
        engineInstanceId = data.engineInstanceId
      }
      this.$API
        .updateAppAttr({
          param: {
            publicId: engineInstanceId,
            linkNoProxy: newVal
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$changeOptionsEV(newVal, "linkNoProxy", false, null, {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            })
          }
        })
    },
    async signPagination(newVal){
      let engineInstanceId = this.getOptions.engineInstanceId
      if(!engineInstanceId){
        const data = !this.hasGetDetailDataPlugin && await this.getAppointDataEv() || {}
        engineInstanceId = data.engineInstanceId
      }
      this.$API
        .updateAppAttr({
          param: {
            publicId: engineInstanceId,
            linkNoProxy: newVal
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$changeOptionsEV(newVal, "linkNoProxy", false, null, {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            })
          }
        })
    },
    // 过滤详情页的参数
    getDetailParam() {
      if (this.pageType === "detailPage") {
        let detailData = localStorage.getItem("detailData")
        detailData = detailData ? JSON.parse(detailData)[0] : {}
        console.log("detailData", detailData)
        for (let key in detailData) {
          if (detailData[key] && detailData[key].key !== null && typeof detailData[key].key !== "undefined") {
            this.detailParams.push({
              label: detailData[key].key,
              value: detailData[key].value
            })
          }
        }
      }
    },
    checkShowTabs(name) {
      if (typeof this.showColsData === "boolean") return this.showColsData
      return !!this.showColsData.find(it => it === name)
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    collapseMouseDown($event, val) {
      if (val === "2" && this.filedMappingList.length === 0) {
        if (this.isSearchListPage) {
          this.getSearchListData()
        }
        if (this.isGroupSearchListPage) {
          this.getGroupSearchListData()
        }
      }
      if (val === "3" && this.allCols.length === 0) {
        this.getAllCols()
      }
      if (val === "4") {
        this.initDetailsPageHandle()
      }
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    //  绑定数据源之后，转换成图文样式
    convertToGaphic(){
      let menu =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu
          : this.request_prefix === "appStage"
          ? this.$store.state.appMenu.menu
          : this.$store.state.menu.menu
      let gaphic =menu.moduleTypes.find(item=>item.name === '图文列表')
      if(!gaphic){
        return
      }
      let newOptions = JSON.parse(JSON.stringify(this.getOptions))
      newOptions = {
         ...newOptions,
        "encId": "", // 不需要，这是组件的唯一id
        "typeId": "",
        "componentTypeId": gaphic.encId,
        "menuName": "图文列表",
        "name": "图文列表",
        "isSystemComponent": true,
        "isIndependenceComponent": true,
        "componentTypeName": "cxGaphic",
        "isDefaultComponent": false,
        "isLocalStyle": true // 用于判断是不是空的自由布局绑定的外接数据源
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", {
        ...this.ids,
        options: newOptions
      })
    },
    setMyFetchParam() {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      let appId = rectAttr.appId || this.getOptions.appId
      this.$changeOptionsEV(
        {
          typeVal: this.cacheDataTypes.map(it => it.value),
          restDataUrl: this.restDataUrl,
          pageId: pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        },
        true
      )
    },
    goToChooseData() {
      console.log("this.getOptions",this.getOptions)
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      let { moduleId, appId } = this.getOptions
      if (moduleId === undefined) moduleId = this.getOptions?.moduleId
      if (appId === undefined) appId = this.getOptions?.appId
      if (!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "general" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
                // 此时绑定了appId,需要转换成图文样式
                this.setMyFetchParam()
                this.convertToGaphic()
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if(!this.getOptions.isSystemComponent){
        // 兼容现有模版
        this.convertToGaphic()
      }
      if (appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      // 数据自动渲染
      this.appId = appId
      window.addEventListener("storage", this.listenData)
    },
    // 获取当前tab下面的所有col
    getAllCols() {
      if (!this.ids.uid) return // 没有uid说明选中的是整个布局，只有选中布局中的col才进后续逻辑
      let syncColUids = [] // 除去当前选中的col的所有col的uid集合
      const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      const pOptions = [this.getOptions.rows[useActiveIndex]]
      handleFindLayoutComponentAllUid(pOptions, syncColUids)
      syncColUids = [...syncColUids.filter(item => item !== this.ids.uid)]
      for (let i = 0; i < syncColUids.length; i++) {
        const obj = {
          uid: syncColUids[i],
          isChecked: false
        }
        this.allCols.push(obj)
      }
    },
    async getAppointDataEv() {
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const appId = this.getOptions.appId ? this.getOptions.appId : this.getOptions?.myFetchParam?.appId
      return await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId,
        { useSubPageQuery: this.getOptions.useSubPageQuery, selectedDetailParam: this.getOptions.selectedDetailParam }
      )
    },
    getSearchListData() {
      const { pageId } = this.$store.state.states.getDataPageIds
      let completeData = window.localStorage.getItem("searchListData-" + pageId)
      if (completeData) {
        completeData = JSON.parse(completeData)
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([this.getOptions.rows[0]])
        let activeIndex = colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
        if (completeData && completeData[activeIndex]) {
          // 组装字段映射的数据结构
          Object.keys(completeData[activeIndex]).forEach((key, index) => {
            if (completeData[activeIndex][key]?.label) {
              const temp = {
                value: key,
                label: completeData[activeIndex][key]?.label
              }
              this.filedMappingList.push(temp)
            }
          })
        }
        this.completeData = completeData
      }
    },
    getGroupSearchListData() {
      const { pageId } = this.$store.state.states.getDataPageIds
      let completeData = window.localStorage.getItem("groupSearchListData-" + pageId)
      if (completeData) {
        completeData = JSON.parse(completeData)
        const rectAttr = this.getRectAttribute(this.ids)
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([rectAttr.options.rows[0]])
        let activeIndex = colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
        if (completeData && completeData[activeIndex]) {
          // 组装字段映射的数据结构
          Object.keys(completeData[activeIndex]).forEach((key, index) => {
            if (completeData[activeIndex][key]?.label) {
              const temp = {
                value: key,
                label: completeData[activeIndex][key]?.label
              }
              this.filedMappingList.push(temp)
            }
          })
        }
        this.completeData = completeData
      }
    },
    // 同步自由布局组件tabs的值
    async startDraw(type) {
      if(!this.getOptions.isSystemComponent && this.getOptions.appId){
        // 兼容现有模版
        this.convertToGaphic()
      }
      console.log("in")
      try {
        if ((!(await this.showDataSetting()) || !this.noCacheComponent) && !this.getOptions.multiImageDetail) return
      } catch(e) {
        return
      }
      const { cacheDataTypes, restDataUrl, restUrl } = this
      console.log("restUrl", restUrl)
      if (type === "addType") {
        // 满足北师大项目插件需求
        let maxIndex = restUrl?.data?.data?.generalDataTypes?.length - 1
        if (this.getOptions?.pluginName?.includes("fetch-twoTabsLayoutPlugin")) {
          maxIndex = restUrl?.data?.data?.generalDataTypes?.length
        }
        const currentRowsLength = this.getOptions.rows?.length || 0
        // 同步新增分类下的数据样式
        for (let i = currentRowsLength; i <= maxIndex; i++) {
          const result = {
            ...this.ids,
            content: JSON.parse(JSON.stringify([this.getOptions.rows[0]]))[0],
            index: i
          }
          deepChangeUid(result.content)
          this.$store.dispatch(this.request_prefix + "/changeTabMapRowContent", result)
        }
        return
      }
      // 上传的系统样式切换后publicId不对应 如不同在此处重新赋值
      let publicId = restUrl?.data?.data?.engineInstance?.publicId
      if (publicId && this.getOptions.publicId !== publicId) {
        this.$changeOptionsEV(publicId, "publicId", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }, true)
      }
      const updateLayoutData = new UpdateLayoutData(this)
      const { completeData, drawLayoutAlready, colsIdFromActiveRect, totalRecords, pageSize } =
        await updateLayoutData.upDateRect({
          activeIndex: this.getOptions.activeIndex,
          rectAttr: this.getOptions,
          cacheDataTypes: cacheDataTypes,
          restDataUrl: restDataUrl,
          categoryMode: this.getOptions?.categoryMode,
          ids: this.ids,
          renderModel: this.isTypeRenderMode ? 'type' : 'data',
          wholeDataTypes: this.wholeGeneralDataTypes,
          dataCenterContent: this.dataCenterContent,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: (param, opacity, display) => {
            if (opacity === 0 && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "block"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: (completeParam, opacity, display) => {
            let completeParamClone = Object.assign({}, completeParam)
            if (!opacity && !display) {
              // 把透明度重置为1
              completeParamClone.option_name = "opacity"
              completeParamClone.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            }
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParam)
            completeParamClone.option_name = "display"
            const noEmpty = completeParam.option_val !== "" && isExist(completeParam.option_val)
            completeParamClone.option_val = noEmpty ? "block" : "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: (ids, opacity) => {
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "display"
            completeparam.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            if (!opacity) {
              // 把透明度重置为1
              completeparam.option_name = "opacity"
              completeparam.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            }
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)

            const dataIdParam = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }

            const pageTypeParam = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)

            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
          }
        })
      /**
       * !!!!!初始化自由布局中的其他组件（分页、tabs分类、多级导航、垂直多级导航、标题、更多）
       * !!!!考虑到自由布局的使用场景不同，需要先判断组件是否存在，在进行对应的业务数据填充
       */
      const AllOtherComponents = findAllComponentsInTitleOptions(this.getOptions)
      if (AllOtherComponents.length === 0) return
      for (let i = 0; i < AllOtherComponents.length; i++) {
        switch (AllOtherComponents[i].type) {
          case "classification":
            // 初始化tabs组件
            this.initTabsData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl, this.getOptions.multiImageDetail)
            break
          case "pagination":
            // 初始化分页组件
            this.initPaginationData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              totalRecords,
              pageSize
            )
            break
          case "more":
            // 初始化更多组件
            break
          case "breadCrumbs":
            // 初始化面包屑组件
            this.initBreadCrumbsData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              restUrl
            )
            break
          case "navMenuVertical":
            // 初始化多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
          case "navMenuVertical":
            // 初始化垂直多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
        }
      }
      // 按钮弹窗请求接口需求
      if (this.getOptions.hasOwnProperty("clickState")) this.clickState = ""
      if (this.getOptions.hasOwnProperty("requestUrl")) this.requestUrl = ""
      const tempComplete = completeData && completeData[this.getOptions.activeIndex]
      // 重新组装字段映射的数据结构
      this.filedMappingList = []
      this.filedMappingList = this.getFieldMappingList(tempComplete, this.getOptions)
      this.completeData = completeData
      this.colsIdFromActiveRect = colsIdFromActiveRect
      this.startGetUserChoose(completeData, drawLayoutAlready, updateLayoutData)
    },
    // 获取字段映射列表
    getFieldMappingList(tempComplete, options) {
      let filedMappingList = []
      if (options?.pluginName?.includes('renderTypeCol')) {
        // 说明是单元格渲染分类数据的模式
        return TYPE_FIELD_MAPPING
      }
      if (tempComplete) {
        Object.keys(tempComplete).forEach(key => {
          if (!tempComplete[key]) return
          // 以前会绑定到自由布局上，新做的是绑定到按钮上，此处屏蔽掉
          // if (tempComplete[key].key === "clickStatus") {
          //   this.clickState = tempComplete[key].value
          // }
          // if (tempComplete[key].key === "requestUrl") {
          //   this.requestUrl = tempComplete[key].value
          // }
          if (key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
            const temp = {
              value: key,
              label: tempComplete[key]?.key
            }
            filedMappingList.push(temp)
          }
          if (key === "viewNum") {
            const temp = {
              value: key,
              label: "浏览量"
            }
            filedMappingList.push(temp)
          }
        })
      }
      return filedMappingList
    },
    async startGetUserChoose(completeData, drawLayoutAlready, updateLayoutData) {
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      //数据处理
      if (drawLayoutAlready) {
        // 预先画好了布局,但没画完
        updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
      } else {
        //没有预先画好布局 是否自动生成？
        const menus =
          this.request_prefix === "bigScreen"
            ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
            : this.$store.state.menu.menu.children[1].children
        updateLayoutData.createLayoutComponent(completeData, null, null, menus)
      }
    },
    async showDataSetting() {
      // 搜索列表页不需要给自由布局组件设置数据
      if (this.isSearchListPage || this.isGroupSearchListPage) return false
      if (!this.checkStatus) {
        return false
      }
      this.noCacheComponent = true
      this.chooseFromVisable = !this.chooseFromVisable
      const { engineInstanceId, cacheDataTypes, restDataUrl, restUrl, generalDataTypes, engineInstance, dataCenterContent } = await this.getAppointDataEv()
      this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, {
        rect_id: this.ids.rect_id,
        container_id: this.ids.container_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }, true)
      if (engineInstance) {
        //数据推送需要的属性
        this.$changeOptionsEV(engineInstance.id, "engineInstanceId_10", false, null, this.myId, true)
      }
      this.restDataUrl = restDataUrl
      this.restUrl = restUrl
      this.cacheDataTypes = cacheDataTypes
      this.wholeGeneralDataTypes = generalDataTypes
      this.dataCenterContent = dataCenterContent
      return true
    },
    // 改变filedMapping的值
    changeFiledMappingHandle(data, params, isGetData) {
      console.log("ininin")
      let { activeIndex } = this.getOptions
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        uid: this.ids.uid,
        elementInLayoutId: params.elementInLayoutId,
      }
      let elementInAutoLayoutId = this.ids.elementInAutoLayoutId !== undefined ? this.ids.elementInAutoLayoutId : params.elementInAutoLayoutId
      let path = this.ids.hasOwnProperty("path") ? this.ids.path : params.path
      if (elementInAutoLayoutId !== undefined) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.ids.uid,
          elementInLayoutId: params.elementInLayoutId,
          elementInAutoLayoutId: elementInAutoLayoutId,
          path: path,
        }
      }
      let currentFiledMapping = JSON.parse(
        JSON.stringify(
          this.$getOptions(ids).filedMapping
        )
      )
      if (params.flag === "checked") {
        currentFiledMapping.checked = data
        this.changeLinksHandle(data, params.elementInLayoutId)
      } else if (params.flag === "dataType") {
        currentFiledMapping[params.flag] = data
      } else if (params.flag === "linkUrl") {
        currentFiledMapping.linkUrl = data
      } else if (params.flag === "value") {
        currentFiledMapping.value = data
        if(data) {
          currentFiledMapping.flag = true
        }
        // 判断当前选中字段类型，如果是日期字段，则需要显示日期格式设置项
        const tempComplete = this.completeData[activeIndex]
        tempComplete && Object.keys(tempComplete).forEach(key => {
          if (key === data) {
            currentFiledMapping.dateStyle = "1"
            if (tempComplete[key].component_shape?.includes("cxDate")) {
              currentFiledMapping.isDate = true
            } else {
              currentFiledMapping.isDate = false
            }
          }
        })
      }
      this.$changeOptionsEV(currentFiledMapping, "filedMapping", false, null, {
        rect_id: this.ids.rect_id,
        container_id: this.ids.container_id,
        uid: this.ids.uid,
        elementInLayoutId: params.elementInLayoutId,
        elementInAutoLayoutId: elementInAutoLayoutId,
        path: path
      }, true)

      if (currentFiledMapping.value === "viewNum") {
        this.$changeOptionsEV(true, "isHasViewNum", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: elementInAutoLayoutId,
          path: path
        }, true)
      }

      if (this.isSearchListPage || this.isGroupSearchListPage) {
        this.$changeOptionsEV(currentFiledMapping, "filedMapping", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          uid: this.ids.uid,
          elementInLayoutId: params.elementInLayoutId,
          elementInAutoLayoutId: elementInAutoLayoutId,
          path: path
        }, true)
        // 通知列表更新数据
        this.$eventBus.$emit(`update-layout-data-eventBus-${this.ids.container_id}-${this.ids.rect_id}`, {
          searchKey: "",
          isGroupSearch: this.isGroupSearchListPage ? true : false
        })
        return
      }

      // 手动触发一次数据响应
      if (isGetData && !this.isSearchListPage && !this.isGroupSearchListPage) {
        this.startDraw()
      }
    },
    // 改变跳转组件
    changeLinksHandle(flag, index) {
      const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      const pOptions = [this.getOptions.rows[useActiveIndex]]
      let detailPageElementIndexList = JSON.parse(
        JSON.stringify(handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid).detailsPageTarget)
      )
      // 兼容老数据返回值为{}会报错
      if (!Array.isArray(detailPageElementIndexList)) {
        detailPageElementIndexList = []
      }
      if (flag) {
        detailPageElementIndexList.push(index)
      } else {
        detailPageElementIndexList = detailPageElementIndexList.filter(val => val !== index)
      }
      // 当删除元素后 清除掉多余的选中态
      let allLayoutId = []
      this.getAllElements.forEach(item => {
        allLayoutId.push(item.elementInLayoutId)
      })
      detailPageElementIndexList = detailPageElementIndexList.filter(val => allLayoutId.includes(val))
      // 全选按钮状态控制
      if (detailPageElementIndexList.length === 0) {
        this.allElementsIsCheckedAll = false
        this.getAllElementsIsCheckedAll = false
      } else {
        if (detailPageElementIndexList.length !== this.getAllElements.length) {
          this.allElementsIsCheckedAll = true
        } else {
          this.allElementsIsCheckedAll = false
        }
      }
      const param = {
        rect_id: this.ids.rect_id,
        container_id: this.ids.container_id,
        uid: this.ids.uid,
        option_val: detailPageElementIndexList,
        option_name: "detailsPageTarget",
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
    },
    // 高亮显示当前组件
    highlightedBaseComponent(index, elementInAutoLayoutId, path) {
      let container = document.getElementById(`componentBox_after${this.ids.uid}`)
      let _class = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.ids.uid}-elementInLayoutId_${index}`
      const isElementInAutoLayout = elementInAutoLayoutId !== undefined && elementInAutoLayoutId !== null
      if (isElementInAutoLayout) {
        _class = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.ids.uid}-elementInLayoutId_${index}-elementInAutoLayoutId_${elementInAutoLayoutId}-path_${path ? path.join('') : path}`
        container = document.getElementsByClassName(_class)[0]
      }
      const dom = document.getElementsByClassName(_class)
      const box = document.createElement("div") //创建元素
      let styleObject = {
        transform: dom[0].style.transform,
        "margin-left": dom[0].style.marginLeft,
        top: dom[0].style.top,
        position: "absolute",
        background: "rgba(118, 163, 211, 0.7);",
        width: dom[0].style.width,
        height: dom[0].style.height
      }
      if (isElementInAutoLayout) {
        styleObject = {
          top: 0,
          left: 0,
          position: "absolute",
          background: "rgba(118, 163, 211, 0.7);",
          width: dom[0].style.width,
          height: dom[0].style.height
        }
      }
      let styleArr = []
      Object.keys(styleObject).forEach(key => {
        styleArr.push([key, styleObject[key]].join(":"))
      })
      box.setAttribute(
        "id",
        `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.ids.uid}-elementInLayoutId_${index}-mask`
      )
      box.setAttribute("style", styleArr.join(";"))
      container.appendChild(box)
    },
    // 取消高亮显示当前组件
    cancelHighlightedBaseComponent(index) {
      document
        .getElementById(
          `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.ids.uid}-elementInLayoutId_${index}-mask`
        )
        .remove()
    },
    // 高亮显示当前col
    highlighted(uid) {
      document.getElementById("componentBox_after" + uid).classList.add("activeCol")
    },
    // 取消高亮显示当前col
    cancelHighlighted(uid) {
      document.getElementById("componentBox_after" + uid).classList.remove("activeCol")
    },
    changeColsCheckedHandle(val, index) {
      let checkedCols = 0
      this.allCols[index].isChecked = val
      this.allCols.map(item => {
        if (item.isChecked) {
          checkedCols++
        }
      })
      if (checkedCols === 0) {
        this.allColsIsCheckedAll = false
        this.getAllColsIsCheckedAll = false
      } else {
        if (checkedCols !== this.allCols.length) {
          this.allColsIsCheckedAll = true
        } else {
          this.allColsIsCheckedAll = false
          this.getAllColsIsCheckedAll = true
        }
      }
    },
    // 打开跳转链接抽屉的时候，初始化
    initDetailsPageHandle() {
      const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
      const pOptions = [this.getOptions.rows[useActiveIndex]]
      const colOptions = handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid)
      if (!colOptions.detailsPageTarget) {
        // 兼容老组件，没有跳转详情配置项
        const param = {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
          uid: this.ids.uid,
          option_val: [],
          option_name: "detailsPageTarget"
        }
        this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
        this.detailPageElementIndexList = []
      } else {
        this.detailPageElementIndexList = Array.isArray(colOptions.detailsPageTarget)
          ? [...colOptions.detailsPageTarget]
          : []
      }
    },
    // 选中所有col
    checkAllColsHandle($event) {
      this.allElementsIsCheckedAll = false // 去掉部分选中状态
      this.allCols.map(item => (item.isChecked = $event))
    },
    // 选中所有元素
    checkAllElementsHandle($event) {
      this.allElementsIsCheckedAll = false // 去掉部分选中状态
      for (let i = 0; i < this.getAllElements.length; i++) {
        this.changeFiledMappingHandle($event, {
          elementInLayoutId: this.getAllElements[i].elementInLayoutId,
          elementInAutoLayoutId: this.getAllElements[i].elementInAutoLayoutId,
          path: this.getAllElements[i].path,
          flag: "checked"
        })
      }
    },
    // 请求数据完成后初始化tab组件
    initTabsData(directionIndex, elementInLayoutId, restUrl, multiImageDetail) {
      let tabsData = []
      if(restUrl && !multiImageDetail) {
        restUrl.data.data.generalDataTypes.forEach(item => tabsData.push({ id: item.publicId, name: item.name, backIconUrl: item.iconUrl, backActiveIconUrl: item.backgroundUrl }))
      }
      // 满足北师大项目插件需求
      if (this.getOptions?.pluginName?.includes("fetch-twoTabsLayoutPlugin")) {
        tabsData.unshift({
          name: "我常用的",
          id: "0"
        })
      }
      // 最大个数限制
      const elementOptions = this.getOptions.titleOptions[directionIndex].elementOptions
      let tabs = undefined
      if (elementOptions.length > 0) {
        tabs = elementOptions.find(item => item.elementInLayoutId === elementInLayoutId)
      }
      if (tabs && tabs.options && tabs.options.isCustomTabsNum) {
        tabsData = tabsData.slice(0, tabs.options.maxLength)
      }
      // 同步分类的时候，需要把多余的row删除，不够的补上一行一列的容器
      const tabParams = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInLayoutId: elementInLayoutId,
        directionIndex: directionIndex,
        maxLength: tabsData.length > 0 ? tabsData.length : 1, // tab的c长度不能为0
        isAsyncData: true,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", tabParams)
      let param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "tabsList",
        option_val: tabsData,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      if (this.getOptions.tabsList?.length !== tabsData?.length) {
        this.$changeOptionsEV(tabsData, "tabsList", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }, true)
      }
      recordOldSize.call(this, this.getOptions)
    },
    // 请求数据完成后初始化分页组件
    initPaginationData(directionIndex, elementInLayoutId, total, pageSize) {
      if (!!total) {
        let param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "total",
          option_val: total,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      }
      if (!!pageSize) {
        let param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "pageSize",
          option_val: pageSize,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path,
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      }
    },
    // 请求数据完成后初始化面包屑组件
    initBreadCrumbsData(directionIndex, elementInLayoutId, restUrl) {
      console.log("restUrl", restUrl)
      const homePageId = this.$store.state[this.request_prefix].page.homePageId
      const newUrl = replaceUrlParam(window.location.href, "p", homePageId)
      let defaultParam = restUrl.data.data.generalDataTypes[0]
      // todo
      // 现在没有地方取到应用名称，先暂时写死应用名称
      const sourceData = [
        {
          label: "首页",
          path: newUrl
        },
        {
          label: this.getOptions.name ? this.getOptions.name : "图文"
        },
        {
          label: defaultParam?.name,
          value: defaultParam?.publicId
        }
      ]

      const param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "sourceData",
        option_val: sourceData,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
    },
    // 请求数据完成后初始化多级导航
    initNavMenuData(directionIndex, elementInLayoutId, restUrl) {
      let navMenuData,
        targetData = []
      navMenuData = restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypes(navMenuData, targetData)
      let param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "selectOptions",
        option_val: targetData,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      let valueParam = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "value",
        option_val: navMenuData[0]?.publicId,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path,
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", valueParam)
    },
    // 递归找到数据分类层级
    recursiveFindDataTypes(navMenuData, targetData) {
      for (let key in navMenuData) {
        targetData.push({
          label: navMenuData[key].name,
          value: navMenuData[key].publicId,
          iconUrl: navMenuData[key].iconUrl,
          children: []
        })
        if (typeof navMenuData[key].subGeneralDataTypes == "object") {
          this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    listenData(e) {
      let id = window.localStorage.getItem("page-v2-data-update-id")
      let appId = this.appId
      if (!appId) appId = this.getOptions?.appId
      if (e.key == "page-v2-general-data-type-add") {
        if (id == appId) {
          console.log("后台分类数据更新 :>>")
          this.startDraw("addType")
        }
      }
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        if (id == appId) {
          console.log("后台配置或数据更新 :>>")
          this.startDraw()
        }
      }
    },
    fieldMappingDataType(filedMapping) {
      const item = this.dataTypeList.find(data => data.value === filedMapping.dataType)
      return item.label || ""
    },
    fieldMappingDateStyle(filedMapping) {
      const item = this.dateOptions.find(data => data.value === filedMapping.dateStyle)
      return item.label || ""
    },
    onChangeMappingType(value, options) {
      this.changeFiledMappingHandle(
        value,
        {
          elementInLayoutId: options.elementInLayoutId,
          elementInAutoLayoutId: options.elementInAutoLayoutId,
          path: options.path,
          flag: "dataType"
        },
        true
      )
    },
    onChangeMappingDateStyle(value, options) {
      options.filedMapping.dateStyle = value
      this.startDraw()
    },
    onChangeMappingDateTitle() {
      this.startDraw()
    },
    onDataCenterChange() {
      this.startDraw()
    },
    updateToolbarData() {
      this.startDraw()
    },
    onBeforeDataCenterUpdate() {
      this.localManual = false
      this.isLocal = this.getOptions.multiImageDetail ? "3" : true
    },
    onAfterDataCenterUpdate(source, typeId, engineInstance) {
      this.localManual = false
      this.source = source
      this.isLocal = this.getOptions.multiImageDetail ? "3" : source === 1
      const moreUrl = engineInstance?.moreUrl
      this.$changeOptionsEV(checkIsYzDatacenter(typeId), "useYzDataCenter", false, null, {
        ...this.ids
      }, true)
      if (moreUrl && checkIsYzDatacenter(typeId)) {
        // 同步更多按钮里面的linkUrl值
        const allOtherComponents = findAllComponentsInTitleOptions(this.getOptions)
        const moreButton = allOtherComponents.find(item => item.type === 'more') 
        if (!moreButton) return
        this.$changeOptionsEV(decodeURIComponent(moreUrl), "linkUrl", false, null, {
          ...this.ids,
          directionIndex: moreButton.directionIndex,
          elementInLayoutId: moreButton.elementInLayoutId
        })
      }
    },
    changeItemOptions(data, params, type) {
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        uid: this.ids.uid,
        elementInLayoutId: params.elementInLayoutId,
      }
      let elementInAutoLayoutId = this.ids.elementInAutoLayoutId !== undefined ? this.ids.elementInAutoLayoutId : params.elementInAutoLayoutId
      let path = this.ids.hasOwnProperty("path") ? this.ids.path : params.path
      if (elementInAutoLayoutId !== undefined) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.ids.uid,
          elementInLayoutId: params.elementInLayoutId,
          elementInAutoLayoutId: elementInAutoLayoutId,
          path: path,
        }
      }
      this.$changeOptionsEV(data, type, false, null, ids, false)
    }
  },
  mounted() { 
    this.getDetailParam()
    if(this.getOptions.multiImageDetail) {
      this.localManual = false
      this.isLocal = "3"
      this.startDraw()
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenData)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  }
}
</script>

<style lang="scss" scoped>
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}

.getDataBtn {
  display: none;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: rgba(0, 0, 0, 0.2);
}

.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px 4px;
}

::v-deep .el-button--primary {
  background-color: var(--themeColor);
}
::v-deep .el-radio {
  margin-top: 16px;
}
::v-deep .el-el-radio__label {
  font-size: 14px;
  line-height: 20px;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 8px;
}
::v-deep .verticallyCenter .el-checkbox {
  margin-right: 0;
}
::v-deep .mapping_date_content .el-input .el-input__inner {
  background: var(--inputArrowBgColor);
}
.custom-param-checkbox .el-checkbox {
  display: block;
}
.mapping_content {
  padding: 8px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.custom-dropdown.bigScreen {
  .dropdown-title-show {
    border-color: rgba(55, 55, 55, 1);
  }
  ::v-deep .el-dropdown-menu__item {
    color: rgba(255, 255, 255, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.verticallyBetweenCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
